import {
  FunctionInformation,
  GetViewsResponse,
  PlanningForm,
  CreateViewPlanningResponse,
  GetTasksFromViewPlanningResponse,
  GetSensorsInUseInPlanningsResponse,
  GetSensorsStatusInPlanningsResponse,
  UpdateViewPlanningResponse,
} from '../../types/types';
import { _getArgosV25, _postArgosV25, _putArgosV25 } from './_internal';

export const getFunctions = () => {
  const route = 'api/functions';
  return _getArgosV25({ route: route });
};

export const getFunctionById = (payload: { functionId: number }) => {
  const route = `api/function/${payload.functionId}`;
  return _getArgosV25({ route: route });
};

export const getTasksByIdProject = (payload: { projectIds: number[] }) => {
  const route = `api/task/projects?project_ids=${payload.projectIds.join(',')}`;
  return _getArgosV25({ route: route });
};

export const getViews = (): Promise<GetViewsResponse> => {
  const route = 'api/view';
  return _getArgosV25({ route: route });
};

export const getFunctionInformation = (
  payload: any
): Promise<FunctionInformation[]> => {
  const route = `api/view/${payload.viewType}`;
  return _getArgosV25({ route: route });
};

export const createViewPlanning = (
  payload: PlanningForm
): Promise<CreateViewPlanningResponse> => {
  const route = 'api/view/schedule';
  return _postArgosV25({ route: route, payload: payload });
};

export const getTasksFromViewPlanning = (payload: {
  viewId: number;
}): Promise<GetTasksFromViewPlanningResponse> => {
  const route = `api/task/${payload.viewId}`;
  return _getArgosV25({ route: route });
};

export const updateViewPlanning = (
  payload: PlanningForm
): Promise<UpdateViewPlanningResponse> => {
  const route = `api/view/schedule`;
  return _postArgosV25({ route: route, payload: payload });
};

export const startModeAuto = (payload: { viewType: string }) => {
  const route = `api/view/schedule/start/${payload.viewType}`;
  return _putArgosV25({ route: route, payload: payload });
};

export const stopModeAuto = (payload: { viewType: string }) => {
  const route = `api/view/schedule/stop/${payload.viewType}`;
  return _putArgosV25({ route: route, payload: payload });
};

export const switchManualMode = (payload: { viewType: string }) => {
  const route = `api/view/schedule/manual/${payload.viewType}`;
  return _postArgosV25({ route: route, payload: payload });
};

export const getSensorsInUseInPlannings = (payload: {
  projectId: number;
}): Promise<GetSensorsInUseInPlanningsResponse> => {
  const route = `api/sensors/${payload.projectId}`;
  return _getArgosV25({ route: route });
};

export const getSensorsStatusInPlannings = (payload: {
  sensor_ids: number[];
}): Promise<GetSensorsStatusInPlanningsResponse> => {
  const route = `api/sensors-status`;
  return _postArgosV25({
    route: route,
    payload: { sensor_ids: payload.sensor_ids },
  });
};
